import React from "react";
import { useTranslation } from "react-i18next";
import { TextInput } from "@common/textInput";
import { ColorForm } from "@common/zoneCreationForm/colorForm";
import { Props } from "./types";
import styles from "./styles.scss";

function ZoneEditionForm(props: Props) {
  const { t } = useTranslation();

  return (
    <div className={styles.zoneEditionForm}>
      <div className={styles.formGroup}>
        <div className={styles.name}>
          <div className={styles.zoneAvatar}>
            <ColorForm
              zone={props.zone}
              selectedColor={props.zone.color}
              selectColor={(color) => props.editForm({ ...props.zone, color })}
            />
          </div>
          <TextInput
            value={props.zone.name}
            placeholder={t("zoneCreation.namePlaceholder")}
            input={(name) => props.editForm({ ...props.zone, name })}
          />
        </div>
        <div className={styles.description}>
          <h2 className={styles.title}>
            {t("zoneEdition.descriptionPlaceholder")}
          </h2>
          <div className={styles.textArea}>
            <TextInput
              value={props.zone.description}
              placeholder={""}
              input={(description) =>
                props.editForm({ ...props.zone, description })
              }
              isMultiline
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export { ZoneEditionForm };
